/*
  Pesquisa do header (snippets/cs-search.liquid).
  Filtra no browser a lista de produtos atuais que vem em JSON no próprio painel.
  Todas as palavras escritas têm de aparecer no produto (título, tipo, frase,
  tradução, tags ou cores); acentos e hífenes são ignorados.
*/
if (!customElements.get('cs-search')) {
  const SYNONYMS = {
    camisola: ['sweat'],
    camisolas: ['sweat'],
    hoodie: ['sweat'],
    hoodies: ['sweat'],
    capuz: ['sweat'],
    sweats: ['sweat'],
    camiseta: ['tshirt'],
    camisetas: ['tshirt'],
    tshirts: ['tshirt'],
    tee: ['tshirt'],
    tops: ['top'],
    almofadas: ['almofada'],
    acessorio: ['acessorios', 'frascos', 'necessaire', 'compress', 'maquina', 'bomba', 'totebag'],
  };

  const normalize = (value) =>
    String(value || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[-‐’'"“”]/g, '')
      .replace(/\s+/g, ' ')
      .trim();

  const escapeHtml = (value) =>
    String(value || '').replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);

  customElements.define(
    'cs-search',
    class CsSearch extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.cs-search__input');
        this.idle = this.querySelector('[data-cs-search-idle]');
        this.results = this.querySelector('[data-cs-search-results]');
        this.grid = this.querySelector('[data-cs-search-grid]');
        this.count = this.querySelector('[data-cs-search-count]');
        this.empty = this.querySelector('[data-cs-search-empty]');
        this.term = this.querySelector('[data-cs-search-term]');
        this.all = this.querySelector('[data-cs-search-all]');

        try {
          this.index = JSON.parse(this.querySelector('[data-cs-search-index]').textContent).map((item) => ({
            ...item,
            haystack: normalize([item.title, item.type, item.phrase, item.phrase_pt, item.tags, item.colors].join(' ')),
            titleKey: normalize(item.title),
          }));
        } catch (error) {
          this.index = [];
        }

        let timer;
        this.input.addEventListener('input', () => {
          clearTimeout(timer);
          timer = setTimeout(() => this.render(), 120);
        });

        // Ao reabrir, mostra o estado certo para o que ficou escrito.
        this.closest('details').addEventListener('toggle', (event) => {
          if (event.target.open) this.render();
        });
        this.render();
      }

      search(query) {
        const tokens = normalize(query).split(' ').filter(Boolean);
        if (!tokens.length) return [];
        return this.index
          .filter((item) =>
            tokens.every((token) => [token, ...(SYNONYMS[token] || [])].some((word) => item.haystack.includes(word)))
          )
          .map((item) => ({
            item,
            score:
              (item.titleKey.startsWith(tokens[0]) ? 3 : 0) +
              tokens.filter((token) => item.titleKey.includes(token)).length * 2 +
              (item.available ? 1 : 0),
          }))
          .sort((a, b) => b.score - a.score)
          .map(({ item }) => item);
      }

      card(item) {
        return `<li class="cs-sc"><a href="${escapeHtml(item.url)}" class="cs-sc__link">
          <span class="cs-sc__media">${
            item.image ? `<img src="${escapeHtml(item.image)}" alt="" loading="lazy" width="600" height="750">` : ''
          }${item.available ? '' : '<span class="cs-sc__badge">Esgotado</span>'}</span>
          ${item.type ? `<span class="cs-sc__type">${escapeHtml(item.type)}</span>` : ''}
          <span class="cs-sc__title">${escapeHtml(item.title)}</span>
          ${item.phrase ? `<span class="cs-sc__phrase">“${escapeHtml(item.phrase)}”</span>` : ''}
          <span class="cs-sc__price">${item.from ? 'Desde ' : ''}${escapeHtml(item.price)}</span>
        </a></li>`;
      }

      render() {
        const query = this.input.value.trim();
        const active = normalize(query).length >= 2;
        this.idle.hidden = active;
        this.results.hidden = !active;
        if (!active) return;

        const matches = this.search(query);
        this.grid.innerHTML = matches.map((item) => this.card(item)).join('');
        this.grid.hidden = matches.length === 0;
        this.empty.hidden = matches.length > 0;
        this.term.textContent = query;
        this.count.textContent =
          matches.length === 0 ? 'Produtos' : `${matches.length} ${matches.length === 1 ? 'produto' : 'produtos'}`;
        this.all.hidden = matches.length === 0;
        this.all.href = `${window.routes?.search_url || '/search'}?q=${encodeURIComponent(query)}&type=product`;
      }
    }
  );
}
